export const isFirstSession = ({ siteId, checkInDate, siteInformation, isSuccess }) => {
  const sameSiteInformation = siteInformation?.find((s) => s.siteId === siteId)

  if (isSuccess) {
    if (!sameSiteInformation) {
      return true
    }
    if (
      sameSiteInformation?.checkInCount === 1 &&
      sameSiteInformation?.lastCheckInOn === checkInDate
    ) {
      return true
    }
  }
  return false
}
